import PropTypes from "prop-types";
import PremierCountry from "../../../components/PremierCountry/index.jsx";
import style from "./styles";

const PremierCountryOption = ({
  assetsUrl,
  countryData,
  countriesData,
  selectedCountry,
  setCountry,
  premierAvailableText,
}) => {
  const context = window?.asos && window.asos.webContext;
  const webContext = {
    currency: context.getBrowseCurrency(),
    language: context.getBrowseLanguage(),
    storeId: context.getStoreId(),
  };
  return (
    <li>
      <button
        className={`${style.PremierCountryOption} ${
          selectedCountry === countryData.country.code ? style.selected : ""
        }`}
        role="radio"
        aria-checked={selectedCountry === countryData.country.code}
        data-country={countryData.country.code}
        tabIndex="0"
        onClick={() =>
          setCountry(
            countryData.country.code,
            countriesData,
            webContext.language,
            webContext.currency,
            webContext.storeId
          )
        }
      >
        <PremierCountry
          countryData={countryData}
          assetsUrl={assetsUrl}
          style={style}
        />
        {countryData.isNewlyAvailable ? (
          <div className={style.NewPremierOptionWrapper}>
            <p className={style.NewPremierOption}>{premierAvailableText}</p>
          </div>
        ) : null}
      </button>
    </li>
  );
};

PremierCountryOption.propTypes = {
  countryData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    country: PropTypes.shape({
      code: PropTypes.string.isRequired,
    }),
    isNewlyAvailable: PropTypes.bool,
  }),
  countriesData: PropTypes.array.isRequired,
  selectedCountry: PropTypes.string.isRequired,
  setCountry: PropTypes.func.isRequired,
  assetsUrl: PropTypes.string.isRequired,
  returnFocus: PropTypes.func.isRequired,
  premierAvailableText: PropTypes.string.isRequired,
};

export default PremierCountryOption;
